import { useParams } from 'react-router-dom';

type RouteParams = Record<string, string | undefined>;

export const useRouteParams = <T extends RouteParams = { id: string }>() => {
	return useParams() as T;
};
